// shared.module.ts

import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GlobalLeadersComponent } from '../Components/global-leaders/global-leaders.component';

@NgModule({
  declarations: [
    GlobalLeadersComponent
  ],
  imports: [
    CommonModule
  ],
  exports: [
    GlobalLeadersComponent
  ]
})

export class GlobalLeadersModule { }
